window.addEventListener('load', function() {
    const _throttle = require('lodash.throttle'); // Import the throttle function

    // Function to initialize the ticker
    function initializeTicker() {
        const tickerContainers = document.querySelectorAll('.ticker-container');

        tickerContainers.forEach(function(tickerContainer) {
            const tickerWrapper = tickerContainer.querySelector('.ticker-wrapper');
            if (tickerWrapper) {
                const totalWidth = tickerWrapper.scrollWidth; // Get the full width of the ticker content
                const speed = 10; // Set speed to 10px per second
                const duration = totalWidth / speed; // Calculate duration in seconds

                // Set the animation duration dynamically based on content width
                tickerWrapper.style.animationDuration = `${duration}s`;
            }
        });
    }

    // Initialize on page load
    initializeTicker();

    // Reinitialize on window resize with throttling
    window.addEventListener('resize', _throttle(initializeTicker, 300));
});
